/**
 * 密码重置 - 第一步：输入邮箱，后端发邮件（永远返成功，防账户枚举）
 *
 * 皮肤移植 design/Novel-admin/Login.html 表单样式；逻辑不变。
 */

import { type FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { AdminApiError } from '~/api/errors';
import { requestPasswordReset } from '~/hooks/use-auth';
import { toast } from '~/ui/Toast';

export default function PasswordResetRequestPage() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await requestPasswordReset(email);
      setDone(true);
    } catch (err) {
      if (err instanceof AdminApiError) toast(err.message, { tone: 'neg' });
      else toast('请求失败', { tone: 'neg' });
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div className="step">
        <div className="bind-success">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
          如该邮箱已注册，重置链接已发送，请查收邮件
        </div>
        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <Link
            to="/auth/login"
            style={{ color: 'var(--accent)', textDecoration: 'none', fontSize: 13 }}
          >
            返回登录
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="step">
      <div style={{ marginBottom: 24 }}>
        <h2 className="form-title">找回密码</h2>
        <p className="form-sub">输入账户邮箱，我们将发送密码重置链接</p>
      </div>

      <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div className="field">
          <label className="field-label" htmlFor="reset-email">
            邮箱
          </label>
          <input
            id="reset-email"
            className="input-big"
            type="email"
            placeholder="you@rivmoon.com"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn-big" style={{ marginTop: 4 }} disabled={submitting}>
          {submitting ? '发送中…' : '发送重置邮件'}
        </button>
        <div style={{ textAlign: 'center' }}>
          <Link
            to="/auth/login"
            style={{ color: 'var(--accent)', textDecoration: 'none', fontSize: 13 }}
          >
            返回登录
          </Link>
        </div>
      </form>
    </div>
  );
}
